import {
  Button,
  Divider,
  message,
  Modal,
  Result,
  Select,
  Table,
  Input,
  Empty,
  Checkbox,
  Tag,
} from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import BarcodeScanner from "../../../components/BarcodeScanner/BarcodeScanner";
import { Base64func } from "../../../components/Base64Func/Base64func";
import OrderDetails from "../../../components/OrderDetailSection/OrderDetails";
import {
  pickerOrderDetailsThunk,
  saveMissingMedicineDetails,
  clearPickerDetails,
} from "../../../redux/PickerOrder/Action";
import "./CheckerOrderPage.css";

import {
  getScannedCheckerOrderDetailsThunk,
  saveCheckerMissingMedicineDetails,
  getMedDetailsThunk,
  editMrpThunk,
  checkIfInvoiceExistsInZohoThunk,
  deleteInvoiceThunk,
  changeQtyThunk,
  addOrUpdateDeskNumberThunk,
  createInvoiceThunk,
  generateInvoicePdfThunk,
  getOrderItembatchesFromNetsuitThunk,
  fetchFromElasticSearchThunk,
  enableDisableMedsThunk,
  addMedicineThunk,
  itemAvailableStockThunk,
  getOrderSummaryDetailsThunk,
} from "../../../redux/newCheckerRedux/Action";
import { printPdfThunk } from "../../../redux/dispatchRedux/Action";
import { markOrderDetailsThunk } from "../../../redux/MarkOrderRedux/Action";
import { PACKAGE_STATUS, warehouseId } from "../../../constants/index";
import { updatePackageStatusThunk } from "../../../redux/packageTrackerRedux/Action";
import IncrementDecrementInput from "../../../components/IncrementDecrementInput/IncrementDecrementInput";
import { RiErrorWarningLine } from "react-icons/ri";
import { GiThermometerCold } from "react-icons/gi";
import { FiPrinter } from "react-icons/fi";
import {
  FooterButtons,
  MedBoxChecker,
  MedBoxCheckerNew,
  MedIssueModalWrapperPicker,
  PreviewWrapper,
} from "./CheckerOrderPage.styled";
import { selectPrinterByDesk } from "../../../components/helper/deskData";
import MedicineLog from "../../../components/MedicineLog/MedicineLog";
import "./CheckerOrderPage.css";
import moment from "moment";
import RxWrapper from "./Components/RxWrapper";
import Viewer from "react-viewer";
import { CloseCircleOutlined } from "@ant-design/icons";

import { checkUrlThunk } from "../../../redux/newCheckerRedux/Action";

const { Option } = Select;
let slideIndex = 0;

export class CheckerOrderPage extends Component {
  state = {
    currentOrderData: null,
    currentOrderId: null,
    currentBoxId: null,
    showScannerScreen: false,
    medData: [],
    updatedMedData: [],
    notSelectedMed: null,
    selectedMed: null,
    missingMedData: null,
    medIssueModal: false,
    batchesToSend: [],
    batchesToSendId: [],
    isFinalScreen: false,
    errorFinalScreen: false,
    showMedTable: false,
    isConfirmSubmit: false,
    coldChainConfirmModal: false,
    allMedDetails: [],
    medMrp: null,
    medSp: null,
    medDiscount: null,
    medQty: null,
    maxQty: 20,
    editMrpModal: false,
    editQtyModal: false,
    serviceLoading: false,
    medReasonData: null,
    deletedInvoice: false,
    showPreview: false,
    tempInvoiceLink: null,
    batchOrPackModal: false,
    isBatchChange: false,
    requiredQty: 0,
    selectedQty: 0,
    batchesById: [],
    isPackChange: false,
    changedMed: null,
    allPackMeds: [],
    packQty: 0,
    addMed: false,
    newPackBatchAdded: false,
    qtyChanged: false,
    isInVoiceCreated: false,
    color: null,
    text: "",
    visible: false,
    customerRx: [],
    customerRxImgs: [],
    customerRxPdfs: [],
    doctorRxImgs: [],
    doctorRxPdfs: [],
    visibleType: null,
    viewPdfURL: false,
    orderSummaryData: null,
    alreadyPrintedModalError: false,
    // orderSummaryData: {
    //   customerRxUrlList: [
    //     "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/RxUpload/6974141/E82BF.jpeg69741412023022618591220230226185912.jpeg",
    //     "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/RxUpload/6974141/E82BF.jpeg69741412023022618591220230226185912.jpeg",
    //     "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/Files/6974141_Sushmita/DoctorPdfRx.pdf",
    //   ],
    //   invoiceUrlList: [
    //     "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/Invoice/6974141_Sushmita/InvoicePdf.pdf",
    //   ],
    //   drxPdfUrlList: [
    //     "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/Files/6974141_Sushmita/DoctorPdfRx.pdf",
    //     "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/Invoice/6974141_Sushmita/InvoicePdf.pdf",
    //   ],
    //   patientDosageUrlList: [
    //     "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/Patient/6974141_Sushmita/PatientPdfRx.pdf",
    //   ],
    //   makerPharmacist: null,
    //   checkerPharmacist: null,
    //   doctor: {
    //     userId: 742,
    //     active: true,
    //     firstName: "Afreen",
    //     lastName: "Makai",
    //     emailAddress: "afreen.makai@truemeds.in",
    //     mobileNo: "9068158035",
    //     alternativeMobileNo: "7892388125",
    //     dob: 807408000000,
    //     userImageId: null,
    //     availableStatus: {
    //       serialId: 83,
    //       name: "USER_AVAILABLE_STATUS",
    //       value: "USER OFFLINE",
    //       description: null,
    //       active: true,
    //       createdOn: null,
    //       createdBy: null,
    //       lastModifiedOn: null,
    //       lastModifiedBy: null,
    //     },
    //     createdOn: 1648105950000,
    //     createdById: 12,
    //     modifiedOn: 1675071240000,
    //     modifiedById: 12,
    //     doctorInvoiceName: "Dr. Afreen Makai`",
    //     lastActivity: 1679419169000,
    //   },
    //   finalOrderPdfUrl:
    //     "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/Images/OrderPDF/6974141/FinalOrderPDF.pdf",
    // },
  };

  getExtension = (filename) => {
    return filename.split(".").pop();
  };

  componentDidMount() {
    message.loading("Loading Details", 0);

    //? Getting order ID from url

    let currPath = window.location.href;

    let currPathArr = currPath.split("/");

    let orderValue = "";

    currPathArr.map((item) =>
      item.includes("orderId") ? (orderValue = item.split("=")[1]) : ""
    );

    var that = this;

    window.onpopstate = function (event) {
      that.props.history.push("/markorder");
    };

    this.setState(
      {
        currentOrderId: Base64func(orderValue, "decode"),
        serviceLoading: true,
      },
      () => {
        this.props.addOrUpdateDeskNumberThunk({
          access_token: this.props.access_token,
          orderId: this.state.currentOrderId,
          deskNumber: this.props.deskNumber,
          history: this.props.history,
        });
        this.getMedOrderDetails();
        this.getOrderSummary();

        // ------------- Testing code
        // ------------------------------------------------------------
        // let customerRxImgs = [];
        // let customerRxPdfs = [];
        // let doctorRxImgs = [];
        // let doctorRxPdfs = [];

        // this.state.orderSummaryData?.customerRxUrlList?.map((k) =>
        //   this.getExtension(k).toLowerCase() === "pdf"
        //     ? customerRxPdfs.push(k)
        //     : customerRxImgs.push({
        //         src: k,
        //       })
        // );

        // this.state.orderSummaryData?.drxPdfUrlList?.map((k) =>
        //   this.getExtension(k).toLowerCase() === "pdf"
        //     ? doctorRxPdfs.push(k)
        //     : doctorRxImgs.push({
        //         src: k,
        //       })
        // );

        // this.setState({
        //   customerRxImgs: customerRxImgs,
        //   customerRxPdfs: customerRxPdfs,
        //   doctorRxImgs: doctorRxImgs,
        //   doctorRxPdfs: doctorRxPdfs,
        // });

        // ------------------------------------------------------------
      }
    );
  }

  onDocumentLoadSuccess = (numPages) => {
    this.setState({
      numPages: numPages,
    });
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.deskNumber &&
      this.props.deskNumber !== prevProps.deskNumber &&
      this.state.currentOrderId
    ) {
      this.props.addOrUpdateDeskNumberThunk({
        access_token: this.props.access_token,
        orderId: this.state.currentOrderId,
        deskNumber: this.props.deskNumber,
        history: this.props.history,
      });
    }
  }

  toggleVisible = (val) => {
    this.setState({
      visible: val,
    });
  };

  viewCurrPDF = (url) => {
    this.setState({
      viewPdfURL: url,
    });
  };

  getOrderSummary = () => {
    let data = {
      access_token: this.props.access_token,
      orderId: this.state.currentOrderId,
      history: this.props.history,
    };

    this.props.getOrderSummaryDetailsThunk(data).then(() => {
      if (this.props.checkerDetails?.orderSummaryError) {
        message.error(this.props.checkerDetails?.orderSummaryError);
      } else if (this.props.checkerDetails?.orderSummaryDetails) {
        let customerRxImgs = [];
        let customerRxPdfs = [];
        let doctorRxImgs = [];
        let doctorRxPdfs = [];

        this.props.checkerDetails?.orderSummaryDetails?.customerRxUrlList?.map(
          (k) =>
            this.getExtension(k).toLowerCase() === "pdf"
              ? customerRxPdfs.push(k)
              : customerRxImgs.push({
                  src: k,
                })
        );

        this.props.checkerDetails?.orderSummaryDetails?.drxPdfUrlList?.map(
          (k) =>
            this.getExtension(k).toLowerCase() === "pdf"
              ? doctorRxPdfs.push(k)
              : doctorRxImgs.push({
                  src: k,
                })
        );

        this.setState({
          customerRxImgs: customerRxImgs,
          customerRxPdfs: customerRxPdfs,
          doctorRxImgs: [],
          doctorRxPdfs: doctorRxPdfs,
          orderSummaryData: this.props.checkerDetails?.orderSummaryDetails,
        });
      }
    });
  };

  getTotalMrp = (code, arr) => {
    let mrp = 0;
    for (let i in arr) {
      let med = arr[i];
      if (med.medActive && med.subsProductCd === code && med.subsMrp) {
        mrp = mrp + med.subsMrp;
      }
    }
    return mrp;
  };

  getTotalSp = (code, arr) => {
    let sp = 0;
    for (let i in arr) {
      let med = arr[i];
      if (med.medActive && med.subsProductCd === code && med.subsSellingPrice) {
        sp = sp + med.subsSellingPrice;
      }
    }
    return sp;
  };

  getTotalQty = (code, arr) => {
    let qty = 0;
    for (let i in arr) {
      let med = arr[i];
      if (med.medActive && med.subsProductCd === code && med.subsQuantity) {
        qty = qty + med.subsQuantity;
      }
    }
    return qty;
  };

  getMedOrderDetails = (fetchOrderStats) => {
    this.props
      .getMedDetailsThunk({
        access_token: this.props.access_token,
        orderId: this.state.currentOrderId,
        history: this.props.history,
      })
      .then(() => {
        message.destroy();
        this.setState(
          {
            allMedDetails: this.props.checkerDetails.allMedDetails
              ?.productSubsMappingList,
          },
          () => {
            let data = {
              orderId: this.state.currentOrderId,
              warehouseId: warehouseId,
              access_token: this.props.access_token,
              fetchOrderStats: fetchOrderStats ? true : false,
              history: this.props.history,
              isOrderAssigned: true,
            };

            if (!fetchOrderStats) {
              this.props.getScannedCheckerOrderDetailsThunk(data).then(() => {
                if (this.props.checkerDetails?.newScannedCheckerOrderError) {
                  message.destroy();
                  message.error(
                    this.props.checkerDetails?.newScannedCheckerOrderError,
                    2
                  );
                  this.setState({ loaderStatus: false, serviceLoading: false });
                  this.props.history.goBack();
                } else {
                  this.setState(
                    {
                      currentOrderData: this.props.checkerDetails
                        ?.newScannedCheckerOrderDetailsSuccess,
                    },
                    () => {
                      let data = {
                        access_token: this.props.access_token,
                        orderId: this.state.currentOrderId,
                      };
                      this.props
                        .getOrderItembatchesFromNetsuitThunk(data)
                        .then(() => {
                          this.setState({ serviceLoading: false });
                          if (this.props.checkerDetails.allBatchDetailsError) {
                            message.error(
                              this.props.checkerDetails.allBatchDetailsError
                            );
                          } else if (
                            this.props.checkerDetails.allBatchDetails
                          ) {
                            let productCodeList = [];

                            let productCodeListMed = [];

                            let missingMedicineDetails = [];
                            this.props.checkerDetails?.newScannedCheckerOrderDetailsSuccess?.missingMedicineDetails?.map(
                              (e) => {
                                if (
                                  !productCodeListMed.includes(e.productCode)
                                ) {
                                  productCodeListMed.push(e.productCode);
                                  let tempArray = [];

                                  this.props.checkerDetails?.newScannedCheckerOrderDetailsSuccess?.missingMedicineDetails?.map(
                                    (f) => {
                                      if (f.productCode === e.productCode) {
                                        tempArray.push(f);
                                      }
                                    }
                                  );

                                  let medicineDetails = {};
                                  medicineDetails.name = e.name;
                                  medicineDetails.medIssue = false;
                                  medicineDetails.productCode = e.productCode;
                                  medicineDetails.orderId = e.orderId;
                                  medicineDetails.batches = tempArray;

                                  missingMedicineDetails.push(medicineDetails);
                                }
                              }
                            );

                            let medicineList = [];
                            this.state.allMedDetails.map((e) => {
                              if (
                                e.medActive &&
                                !productCodeList.includes(e.subsProductCd)
                              ) {
                                productCodeList.push(e.subsProductCd);
                                let medicineDetails = {};
                                let medMrp = this.getTotalMrp(
                                  e.subsProductCd,
                                  this.state.allMedDetails
                                );
                                let medSp = this.getTotalSp(
                                  e.subsProductCd,
                                  this.state.allMedDetails
                                );
                                let medQty = this.getTotalQty(
                                  e.subsProductCd,
                                  this.state.allMedDetails
                                );
                                medicineDetails.name = e.subsMedName;
                                medicineDetails.medActive = e.medActive;
                                medicineDetails.medIssue = false;
                                medicineDetails.productCode = e.subsProductCd;
                                medicineDetails.orderId = this.state.currentOrderId;
                                medicineDetails.qty = medQty;
                                medicineDetails.nsItemId = e.nsItemId;
                                medicineDetails.mrp = (medMrp / medQty).toFixed(
                                  2
                                );
                                medicineDetails.sp = (medSp / medQty).toFixed(
                                  2
                                );
                                medicineDetails.discount = (
                                  ((medMrp / medQty - medSp / medQty) * 100) /
                                  (medMrp / medQty)
                                ).toFixed(2);
                                medicineDetails.batches = this.preSelectBatches(
                                  this.props.checkerDetails?.allBatchDetails
                                    ?.order_itembatches,
                                  e
                                );
                                medicineList.push(medicineDetails);
                              }
                            });

                            //? Need to put sort by max qty function here
                            medicineList = medicineList.sort((a, b) =>
                              a.qty < b.qty ? 1 : -1
                            );

                            this.setState(
                              {
                                medData: medicineList,
                                notSelectedMed: medicineList,
                                missingMedData: missingMedicineDetails,
                              },
                              () => {
                                this.setState(
                                  {
                                    selectedMed: this.state.medData[0],
                                    currentBoxId: this.state.currentOrderData
                                      ?.boxNumber,
                                    medReasonData: this.state.currentOrderData?.reasonMasterList?.filter(
                                      (i) =>
                                        i.name === "CHECKER_REASON" &&
                                        i.active === true
                                    ),
                                  },
                                  () => {
                                    this.setState(
                                      {
                                        requiredQty: this.state.selectedMed
                                          ?.qty,
                                        batchesById: this.state.selectedMed
                                          ?.batches,
                                      },
                                      () => {
                                        if (
                                          this.state.selectedMed?.batches
                                            ?.length > 0
                                        ) {
                                          this.preSetBatchQty(
                                            this.state.selectedMed?.batches
                                          );
                                        }
                                      }
                                    );
                                  }
                                );
                              }
                            );
                          }
                        });
                    }
                  );
                }
              });
            }
          }
        );
      });
  };
  componentDidUpdate = (prevProps) => {
    if (
      prevProps.checkerDetails.newScannedCheckerOrderDetailsSuccess !=
      this.props.checkerDetails.newScannedCheckerOrderDetailsSuccess
    )
      this.tagger();
  };
  tagger = () => {
    let todayTimeStamp = Date.now();
    if (this.props.checkerDetails.newScannedCheckerOrderDetailsSuccess) {
      if (this.props.checkerDetails.newScannedCheckerOrderDetailsSuccess.sdd) {
        this.setState({
          color: "green",
          text: "Hyperlocal",
        });
      } else if (
        moment(
          this.props.checkerDetails.newScannedCheckerOrderDetailsSuccess
            .orderDate
        ).format("DD-MM-YYYY") === moment(todayTimeStamp).format("DD-MM-YYYY")
      ) {
        this.setState({
          color: "yellow",
          text: "Today's Order",
        });
      } else {
        this.setState({
          color: "red",
          text: "Previous Day's Order",
        });
      }
    }
  };
  setQtyByProductCode = (arr, productCode) => {
    let qty = 0;
    for (let i in arr) {
      let med = arr[i];
      if (
        med.subsProductCd ===
        productCode
          .replace("Stage", "")
          .replace("UAT", "")
          .replaceAll(/\s/g, "")
      ) {
        qty = Number(med.subsQuantity);
        break;
      }
    }
    return qty;
  };

  preSelectBatches = (allBatches, med) => {
    let selectedBatches = [];
    let temp = [];
    let isProductBlocked = false;

    if (allBatches?.length > 0) {
      for (let i in allBatches) {
        let batch = allBatches[i];
        if (Number(batch.ns_item_id) === Number(med.nsItemId)) {
          temp = batch.batches;
          isProductBlocked = batch.isProductBlocked
            ? batch.isProductBlocked
            : false;
          break;
        }
      }
      if (temp?.length > 0) {
        for (let i in temp) {
          let tempObj = {};
          let batch = temp[i];
          tempObj.batchNumber = batch.batch_number;
          tempObj.expiryNearBy = batch.expiryNearBy;
          tempObj.isBatchBlocked = batch.isBatchBlocked
            ? batch.isBatchBlocked
            : false;
          tempObj.isProductBlocked = isProductBlocked;
          tempObj.expiryDate = batch.expiry_date;
          tempObj.maxQty = Number(batch.quantity);
          tempObj.mrp = batch.mrp;
          tempObj.rate = batch.rate;
          tempObj.manufacturer_date = batch.manufacturer_date;
          tempObj.external_batch_number = batch.external_batch_number;
          tempObj.finalSubsId = this.setfinalSubsIdSet(
            this.state.allMedDetails,
            med.subsProductCd
          );
          tempObj.ns_item_id = med.nsItemId;
          tempObj.quantity = 0;
          tempObj.ogQty = 0;
          tempObj.isPickSelect = false;
          tempObj.active = false;
          tempObj.reasonId = null;
          tempObj.selected = false;
          tempObj.enabled = false;
          selectedBatches.push(tempObj);
        }
      }
      if (selectedBatches?.length > 0) {
        selectedBatches = selectedBatches.sort((a, b) => {
          if (a.isBatchBlocked === false && b.isBatchBlocked === true) {
            return -1;
          } else if (a.isBatchBlocked === true && b.isBatchBlocked === false) {
            return 1;
          } else {
            if (a.expiryNearBy === false && b.expiryNearBy === true) {
              return -1;
            } else if (a.expiryNearBy === true && b.expiryNearBy === false) {
              return 1;
            }
            return b.maxQty - a.maxQty;
          }
        });
      }
    }
    return selectedBatches;
  };

  changeBoxModal = (value) => {
    this.setState({ showScannerScreen: value });
  };

  updateBoxId = (value) => {
    if (value) {
      this.setState({ currentBoxId: value });
    }
    this.setState({ showScannerScreen: false });
  };

  handleBatchEdit(value, batchKey) {
    let { batchesToSend, batchesToSendId } = this.state;
    let medicineList = this.state.selectedMed;
    medicineList.batches[batchKey]["quantity"] = value;

    let tempBatchArray = batchesToSend;

    if (
      batchesToSendId.includes(medicineList.batches[batchKey].invoiceBatchtId)
    ) {
      batchesToSend[
        batchesToSendId.indexOf(medicineList.batches[batchKey].invoiceBatchtId)
      ] = medicineList.batches[batchKey];
    } else {
      batchesToSend.push(medicineList.batches[batchKey]);
      batchesToSendId.push(medicineList.batches[batchKey].invoiceBatchtId);
    }

    this.setState(
      {
        batchesToSendId: batchesToSendId,
        batchesToSend: tempBatchArray,
        selectedMed: medicineList,
      },
      () => {
        this.setState({
          requiredQty: this.state.selectedMed?.qty,
        });
      }
    );
  }

  handleReasonChange = (value, pos) => {
    let currentUpdateMed = this.state.selectedMed;

    let pickedReason = this.state.medReasonData?.find(
      (i) => i.value === "Picked"
    );

    let pickedKey = pickedReason.reasonId;

    currentUpdateMed.batches[pos]["reasonId"] = value;
    currentUpdateMed.batches[pos]["active"] = true;

    if (pickedKey !== value) {
      currentUpdateMed["medIssue"] = true;
      currentUpdateMed.batches[pos]["isPickSelect"] = false;
    } else {
      currentUpdateMed["medIssue"] = false;
      currentUpdateMed.batches[pos]["isPickSelect"] = true;
    }

    this.setState({ selectedMed: currentUpdateMed }, () => {
      this.setState({
        requiredQty: this.state.selectedMed?.qty,
      });
    });
  };

  saveColdChain = (data) => {
    this.props.saveCheckerMissingMedicineDetails(data).then(() => {
      message.destroy();
      if (this.props.checkerDetails.checkerMissingMedsError) {
        message.error(this.props.checkerDetails.checkerMissingMedsError, 2);
        this.setState({ coldChainConfirmModal: false });
      } else if (this.props.checkerDetails.checkerMissingMeds) {
        message.success(this.props.checkerDetails.checkerMissingMeds?.OK, 2);
        this.coldChainServiceCall();
      } else {
        message.error("Something went wrong", 2);
        this.setState({ coldChainConfirmModal: false });
      }
    });
  };

  //? coldchain function here
  markOrderColdChain = () => {
    message.loading("Please wait...", 0);

    let { selectedMed } = this.state;

    let selectedBatches = [];

    let coldChainReason = this.state.medReasonData?.find(
      (i) => i.value === "Cold Chain"
    );

    if (selectedMed.batches.length > 0) {
      let dataList = [];

      selectedMed.batches.map((e) => {
        let temp = {};
        temp.name = this.state.selectedMed?.name;
        temp.productCode = this.state.selectedMed?.productCode;
        temp.quantity = e.ogQty;
        temp.batchNumber = e.batchNumber;
        temp.orderId = this.state.selectedMed?.orderId;
        temp.active = false;
        temp.reasonId = coldChainReason.reasonId;
        temp.warehouseId = warehouseId;
        if (e.id) {
          temp.id = e.id;
        }
        dataList.push(temp);
      });

      let data = {};
      data.missingMedicineDetailsList = dataList;
      data.access_token = this.props.access_token;

      if (
        selectedMed.name ===
        this.state.medData[this.state.medData.length - 1].name
      ) {
        data.lastMed = true;
      }
      this.saveColdChain(data);
      // let invoiceData = {
      //   access_token: this.props.access_token,
      //   orderId: this.state.currentOrderId,
      //   history: this.props.history,
      // };
      // message.loading("Checking for invoice...", 0);
      // this.props.checkIfInvoiceExistsInZohoThunk(invoiceData).then(() => {
      //   message.destroy();
      //   if (this.props.checkerDetails.checkInvoiceError) {
      //     message.error(this.props.checkerDetails.checkInvoiceError, 2);
      //     this.setState({ coldChainConfirmModal: false });
      //   } else if (this.props.checkerDetails.checkInvoice) {
      //     this.setState({ coldChainConfirmModal: false });
      //     this.saveColdChain(data);
      //   } else {
      //     message.loading("Creating invoice...", 0);
      //     this.props
      //       .createInvoiceThunk({
      //         access_token: this.props.access_token,
      //         orderId: [this.state.currentOrderId],
      //         warehouseId: warehouseId,
      //         history: this.props.history,
      //       })
      //       .then(() => {
      //         message.destroy();
      //         if (this.props.checkerDetails.createInvoiceError) {
      //           message.error(this.props.checkerDetails.createInvoiceError, 2);
      //         } else {
      //           this.saveColdChain(data);
      //         }
      //       });
      //   }
      // });
    }
  };

  coldChainServiceCall = () => {
    let data = {
      packageStatusId: 182,
      awbNoPrinted: false,
      orderId: this.state.currentOrderId,
      // boxSource: "ADMIN_PACKAGE_TRACKER",
      history: this.props.history,
    };
    this.props
      .updatePackageStatusThunk(data, this.props.access_token)
      .then(() => {
        if (this.props.pdf?.updatePackageSuccess) {
          message.success(this.props.pdf?.updatePackageSuccess?.OK, 2);
          this.props.history.push("/markorder");
        } else {
          message.error(this.props.pdf?.updatePackageError, 2);
        }

        this.setState({ coldChainConfirmModal: false });
      });
  };

  verifyMed = (data) => {
    this.props.saveCheckerMissingMedicineDetails(data).then(() => {
      message.destroy();
      if (this.props.checkerDetails.checkerMissingMedsError) {
        message.error(this.props.checkerDetails.checkerMissingMedsError, 2);
      } else if (this.props.checkerDetails.checkerMissingMeds) {
        message.success(this.props.checkerDetails.checkerMissingMeds?.OK, 2);
        this.pageChangeFunction();
      } else {
        message.error("Something went wrong", 2);
      }
    });
  };

  setBatchesForMed = (med, batches) => {
    let selectedMed = med;
    let finalArr = [];
    for (let i in batches) {
      let b = batches[i];
      let btemp = {};
      if (selectedMed.subsQuantity && b.ogQty) {
        if (selectedMed.subsQuantity <= b.ogQty) {
          btemp.batch_number = b.batchNumber;
          btemp.expiry_date = b.expiryDate;
          btemp.itemId = String(b.ns_item_id);
          btemp.mrp = b.mrp;
          btemp.rate = b.rate;
          btemp.manufacturer_date = b.manufacturer_date;
          btemp.external_batch_number = b.external_batch_number;
          btemp.finalSubsId = med.finalSubsId;
          btemp.quantity = selectedMed.subsQuantity;
          b.ogQty = b.ogQty - selectedMed.subsQuantity;
          finalArr.push(btemp);
          break;
        } else {
          btemp.batch_number = b.batchNumber;
          btemp.expiry_date = b.expiryDate;
          btemp.itemId = String(b.ns_item_id);
          btemp.mrp = b.mrp;
          btemp.rate = b.rate;
          btemp.manufacturer_date = b.manufacturer_date;
          btemp.external_batch_number = b.external_batch_number;
          btemp.finalSubsId = med.finalSubsId;
          btemp.quantity = b.ogQty;
          selectedMed.subsQuantity = selectedMed.subsQuantity - b.ogQty;
          b.ogQty = 0;
          finalArr.push(btemp);
        }
      }
    }
    return finalArr;
  };

  pickMedFunction = () => {
    let { selectedMed } = this.state;
    let allSelectedMeds = [];
    allSelectedMeds = this.state.allMedDetails?.filter(
      (e) =>
        e.subsProductCd === this.state.selectedMed?.productCode && e.medActive
    );
    let pickedReason = this.state.medReasonData?.find(
      (i) => i.value === "Picked"
    );
    let allSmeds = [];
    if (allSelectedMeds?.length > 1) {
      let selectBatches = [];
      selectBatches = this.state.selectedMed?.batches;
      this.setState({ selectBatches: selectBatches }, () => {
        for (let i in allSelectedMeds) {
          let temp = {};
          let med = allSelectedMeds[i];
          temp.name = this.state.selectedMed?.name;
          temp.productCode = this.state.selectedMed?.productCode;
          temp.quantity = this.state.selectedMed?.qty;
          temp.orderId = this.state.selectedMed?.orderId;
          temp.active = false;
          temp.reasonId = pickedReason.reasonId;
          temp.warehouseId = warehouseId;
          temp.quantity = med.subsQuantity;
          temp.batches = this.setBatchesForMed(med, this.state.selectBatches);
          allSmeds.push(temp);
        }
        let updateMedIssue = this.state.selectedMed;
        updateMedIssue["medIssue"] = false;
        this.setState({ selectedMed: updateMedIssue }, () => {
          this.setState({
            requiredQty: this.state.selectedMed?.qty,
          });
        });
        if (selectedMed?.batches.length > 0) {
          message.loading("Please wait...", 0);
          for (let k in allSmeds) {
            let tempSMeds = allSmeds[k];
            let data = {};
            data.missingMedicineDetailsList = [tempSMeds];
            data.access_token = this.props.access_token;
            if (
              selectedMed.name ===
              this.state.medData[this.state.medData.length - 1].name
            ) {
              data.lastMed = true;
            }
            if (
              selectedMed.name ===
              this.state.medData[this.state.medData.length - 1].name
            ) {
              this.props.saveCheckerMissingMedicineDetails(data).then(() => {
                message.destroy();
                if (this.props.checkerDetails.checkerMissingMedsError) {
                  message.error(
                    this.props.checkerDetails.checkerMissingMedsError,
                    2
                  );
                } else if (this.props.checkerDetails.checkerMissingMeds) {
                  message.success(
                    this.props.checkerDetails.checkerMissingMeds?.OK,
                    2
                  );
                  if (allSmeds.length === Number(k) + 1) {
                    this.pageChangeFunction();

                    if (
                      this.props.checkerDetails.checkerMissingMeds &&
                      this.props.checkerDetails.checkerMissingMeds[
                        "Box Verified"
                      ]
                    ) {
                      message.loading("Creating invoice...", 0);
                      this.props
                        .createInvoiceThunk({
                          access_token: this.props.access_token,
                          orderId: [this.state.currentOrderId],
                          warehouseId: warehouseId,
                          history: this.props.history,
                        })
                        .then(() => {
                          message.destroy();
                          if (this.props.checkerDetails.createInvoiceError) {
                            message.error(
                              this.props.checkerDetails.createInvoiceError,
                              2
                            );
                          } else {
                            this.setState({ isInVoiceCreated: true });
                          }
                        });
                    }
                  }
                } else {
                  message.error("Something went wrong", 2);
                }
              });
            } else {
              this.props.saveCheckerMissingMedicineDetails(data).then(() => {
                message.destroy();
                if (this.props.checkerDetails.checkerMissingMedsError) {
                  message.error(
                    this.props.checkerDetails.checkerMissingMedsError,
                    2
                  );
                } else if (this.props.checkerDetails.checkerMissingMeds) {
                  message.success(
                    this.props.checkerDetails.checkerMissingMeds?.OK,
                    2
                  );
                  if (allSmeds.length === Number(k) + 1) {
                    this.pageChangeFunction();
                  }
                } else {
                  message.error("Something went wrong", 2);
                }
              });
            }
          }
        } else {
          message.error("No Medicine found", 2);
        }
      });
    } else {
      let updateMedIssue = this.state.selectedMed;
      updateMedIssue["medIssue"] = false;
      this.setState({ selectedMed: updateMedIssue }, () => {
        this.setState({
          requiredQty: this.state.selectedMed?.qty,
        });
      });
      if (selectedMed?.batches.length > 0) {
        message.loading("Please wait...", 0);
        let dataList = [];
        let selectedBatches = [];
        let temp = {};
        temp.name = this.state.selectedMed?.name;
        temp.productCode = this.state.selectedMed?.productCode;
        temp.quantity = this.state.selectedMed?.qty;
        temp.orderId = this.state.selectedMed?.orderId;
        temp.active = false;
        temp.reasonId = pickedReason.reasonId;
        temp.warehouseId = warehouseId;
        selectedMed.batches.map((e) => {
          let btemp = {};
          btemp.batch_number = e.batchNumber;
          btemp.expiry_date = e.expiryDate;
          btemp.itemId = String(e.ns_item_id);
          btemp.quantity = e.ogQty;
          btemp.mrp = e.mrp;
          btemp.rate = e.rate;
          btemp.manufacturer_date = e.manufacturer_date;
          btemp.external_batch_number = e.external_batch_number;
          btemp.finalSubsId = e.finalSubsId;
          selectedBatches.push(btemp);
        });
        temp.batches = selectedBatches;
        dataList.push(temp);
        let data = {};
        data.missingMedicineDetailsList = dataList;
        data.access_token = this.props.access_token;
        if (
          selectedMed.name ===
          this.state.medData[this.state.medData.length - 1].name
        ) {
          data.lastMed = true;
        }
        if (
          selectedMed.name ===
          this.state.medData[this.state.medData.length - 1].name
        ) {
          this.props.saveCheckerMissingMedicineDetails(data).then(() => {
            message.destroy();
            if (this.props.checkerDetails.checkerMissingMedsError) {
              message.error(
                this.props.checkerDetails.checkerMissingMedsError,
                2
              );
            } else if (this.props.checkerDetails.checkerMissingMeds) {
              message.success(
                this.props.checkerDetails.checkerMissingMeds?.OK,
                2
              );
              this.pageChangeFunction();

              if (
                this.props.checkerDetails.checkerMissingMeds &&
                this.props.checkerDetails.checkerMissingMeds["Box Verified"]
              ) {
                message.loading("Creating invoice...", 0);
                this.props
                  .createInvoiceThunk({
                    access_token: this.props.access_token,
                    orderId: [this.state.currentOrderId],
                    warehouseId: warehouseId,
                    history: this.props.history,
                  })
                  .then(() => {
                    message.destroy();
                    if (this.props.checkerDetails.createInvoiceError) {
                      message.error(
                        this.props.checkerDetails.createInvoiceError,
                        2
                      );
                    } else {
                      this.setState({ isInVoiceCreated: true });
                    }
                  });
              }
            } else {
              message.error("Something went wrong", 2);
            }
          });
        } else {
          this.props.saveCheckerMissingMedicineDetails(data).then(() => {
            message.destroy();
            if (this.props.checkerDetails.checkerMissingMedsError) {
              message.error(
                this.props.checkerDetails.checkerMissingMedsError,
                2
              );
            } else if (this.props.checkerDetails.checkerMissingMeds) {
              message.success(
                this.props.checkerDetails.checkerMissingMeds?.OK,
                2
              );
              this.pageChangeFunction();
            } else {
              message.error("Something went wrong", 2);
            }
          });
        }
      } else {
        message.error("No Medicine found", 2);
      }
    }
  };

  setBatches = (med) => {
    let m = med;
    m.batches = this.preSelectBatches(
      this.props.checkerDetails?.allBatchDetails?.order_itembatches,
      med
    );
    return m;
  };

  // Switch next screen function
  pageChangeFunction = () => {
    let { selectedMed } = this.state;
    let notSelected = this.state.notSelectedMed.filter(
      (item) => item.productCode !== selectedMed.productCode && item.medActive
    );
    this.state.updatedMedData.push(selectedMed);
    this.setState({ notSelectedMed: notSelected }, () => {
      if (this.state.updatedMedData.length + (1 % 2) === 0) {
        this.setState(
          {
            selectedMed: this.setBatches(
              this.state.notSelectedMed[this.state.notSelectedMed.length - 1]
            ),
          },
          () => {
            this.setState(
              {
                requiredQty: this.state.selectedMed?.qty,
                batchesById: this.state.selectedMed?.batches,
                selectedQty: 0,
              },
              () => {
                this.preSetBatchQty(this.state.selectedMed?.batches);
              }
            );
          }
        );
      } else {
        this.setState({ selectedMed: this.state.notSelectedMed[0] }, () => {
          this.setState(
            {
              requiredQty: this.state.selectedMed?.qty,
              batchesById: this.state.selectedMed?.batches,
              selectedQty: 0,
            },
            () => {
              this.preSetBatchQty(this.state.selectedMed?.batches);
            }
          );
        });
      }
      if (this.state.updatedMedData.length === this.state.medData.length) {
        if (this.state.updatedMedData.some((item) => item.medIssue)) {
          this.setState({ isFinalScreen: true, errorFinalScreen: true });
        } else {
          this.setState({ isFinalScreen: true });
        }
      }
    });
  };

  handlePicked = () => {
    this.setState({
      loaderStatus: true,
    });
    if (
      this.state.missingMedData.length == 0 ||
      this.state.updatedMedData == this.state.medData.length ||
      this.props.pickerDetails.pickerOrderDetailsSuccess?.packageStatus !=
        PACKAGE_STATUS.PICKED
    ) {
      message.loading("Saving...", 0);
      let data = {};
      data.awbNoPrinted = false;
      data.boxSource = null;
      data.orderId = this.props.pickerDetails.pickerOrderDetailsSuccess
        ? this.props.pickerDetails.pickerOrderDetailsSuccess.orderId
        : "";
      data.packageStatusId = PACKAGE_STATUS.PICKED; //will be specified
      data.history = this.props.history;
      if (data.orderId) {
        this.props
          .updatePackageStatusThunk(data, this.props.access_token)
          .then(() => {
            message.destroy();
            if (this.props.pdf?.updatePackageSuccess) {
              message.success(this.props.pdf?.updatePackageSuccess?.OK, 2);
              setTimeout(() => {
                this.props.history.push("/picker");
              }, 1500);
              // this.getPickerDetails(); //  not to be fetched as it will not be fetched in the listing again - omkar
            } else {
              message.error(this.props.pdf?.updatePackageError, 2);
            }
          });
      } else {
        message.error("OrderId is missing", 2);
      }
    }
  };

  getPriceDetails = (allMeds, med, val) => {
    let selectedVal = "";
    if (allMeds?.length > 0 && med.productCode) {
      for (let i in allMeds) {
        let m = allMeds[i];
        if (
          m.subsProductCd ===
          med.productCode
            .replace("Stage", "")
            .replace("UAT", "")
            .replaceAll(/\s/g, "")
        ) {
          if (val === "mrp") {
            selectedVal = (m.subsMrp / m.subsQuantity).toFixed(2);
          } else if (val === "sp") {
            selectedVal = (m.subsSellingPrice / m.subsQuantity).toFixed(2);
          } else if (val === "discount") {
            selectedVal = (
              ((m.subsMrp / m.subsQuantity -
                m.subsSellingPrice / m.subsQuantity) *
                100) /
              (m.subsMrp / m.subsQuantity)
            ).toFixed(2);
          } else if (val === "qty") {
            selectedVal = m.subsQuantity;
          } else if (val === "maxQty") {
            selectedVal = m.subsMaxCappedQty;
          }
        }
      }
    }
    return selectedVal;
  };

  checkIfQtyAdded = (batches) => {
    let isQtyAdded = false;
    for (let i in batches) {
      let b = batches[i];
      if (b.quantity) {
        isQtyAdded = true;
        break;
      }
    }
    return isQtyAdded;
  };

  // Missing Med function here
  saveMissingMeds = () => {
    let { selectedMed } = this.state;
    let findZero = 0;
    let index = null;
    let medIssue = false;
    let selectedBatches = [];
    let pickedReason = this.state.medReasonData?.find(
      (i) => i.value === "Picked"
    );
    if (selectedMed?.batches?.length > 0) {
      let dataList = [];

      selectedMed.batches.map((e) => {
        if (e.reasonId && Number(e.quantity) === 0) {
          findZero++;
        }

        if ((e.isPickSelect && e.quantity == 0) || !e.isPickSelect) {
          let temp = {};
          temp.name = this.state.selectedMed?.name;
          temp.productCode = this.state.selectedMed?.productCode;
          temp.quantity = e.quantity;
          temp.batchNumber = e.batchNumber;
          temp.orderId = this.state.selectedMed?.orderId;
          temp.active = e.quantity == 0 ? false : true;
          temp.reasonId = e.reasonId ? e.reasonId : pickedReason.reasonId;
          if (e.id) {
            temp.id = e.id;
          }
          temp.warehouseId = warehouseId;
          index = this.state.medData.findIndex((i) => i.name === e.name);

          dataList.push(temp);
        } else {
          medIssue = true;
        }
      });

      if (findZero > 0 || !this.checkIfQtyAdded(selectedMed.batches)) {
        message.error("0 QTY found. Please add QTY to submit", 2);
        return;
      }

      if (medIssue) {
        message.warning("Picked Selected, Quantity must be 0", 2);
        return;
      }

      let data = {};
      data.missingMedicineDetailsList = dataList;
      data.access_token = this.props.access_token;
      if (
        selectedMed.name ===
        this.state.medData[this.state.medData.length - 1].name
      ) {
        data.lastMed = true;
      }

      if (
        selectedMed.name ===
        this.state.medData[this.state.medData.length - 1].name
      ) {
        this.props.saveCheckerMissingMedicineDetails(data).then(() => {
          if (this.props.checkerDetails.checkerMissingMedsError) {
            message.error(this.props.checkerDetails.checkerMissingMedsError, 2);
          } else if (this.props.checkerDetails.checkerMissingMeds) {
            message.success(
              this.props.checkerDetails.checkerMissingMeds?.OK,
              2
            );

            // Setting up medIssue key for updatedMedData
            if (
              this.props.checkerDetails.checkerMissingMeds?.["Medicine Missing"]
            ) {
              let updateMedIssue = this.state.medData;
              if (index >= 0) {
                updateMedIssue[index]["medIssue"] = true;
                this.setState({
                  medData: updateMedIssue,
                });
              }
            }

            this.setState({
              batchesToSendId: [],
              batchesToSend: [],
            });
            this.setState({ medIssueModal: false });
            this.pageChangeFunction();
          } else {
            message.error("Something went wrong", 2);
          }
        });
      } else {
        this.props.saveCheckerMissingMedicineDetails(data).then(() => {
          if (this.props.checkerDetails.checkerMissingMedsError) {
            message.error(this.props.checkerDetails.checkerMissingMedsError, 2);
          } else if (this.props.checkerDetails.checkerMissingMeds) {
            message.success(
              this.props.checkerDetails.checkerMissingMeds?.OK,
              2
            );

            // Setting up medIssue key for updatedMedData
            if (
              this.props.checkerDetails.checkerMissingMeds?.["Medicine Missing"]
            ) {
              let updateMedIssue = this.state.medData;
              if (index >= 0) {
                updateMedIssue[index]["medIssue"] = true;
                this.setState({
                  medData: updateMedIssue,
                });
              }
            }

            this.setState({
              batchesToSendId: [],
              batchesToSend: [],
            });
            this.setState({ medIssueModal: false });
            this.pageChangeFunction();
          } else {
            message.error("Something went wrong", 2);
          }
        });
      }
    } else {
      this.setState({ medIssueModal: false });
      message.error("Looks like you haven't edited anything yet!", 2);
    }
  };

  printInvoice = () => {
    if (!this.props.deskNumber) {
      message.error("Please select a desk to print the invoice", 2);
    } else {
      message.loading("Printing...", 0);
      let data = {
        access_token: this.props.access_token,
        warehouseId: warehouseId,
        orderIds: [this.state.currentOrderId],
        history: this.props.history,
        newAlgo: this.props.checkerDetails?.allMedDetails?.newAlgo,
      };
      this.props.generateInvoicePdfThunk(data).then(() => {
        if (this.props.checkerDetails.invoiceDetailsError) {
          message.destroy();

          this.setState({
            alreadyPrintedModalError: true,
          });
          // message.error(this.props.checkerDetails.invoiceDetailsError, 2);
        } else if (this.props.checkerDetails.invoiceDetails?.OrderPdfLink) {
          this.props
            .checkUrlThunk(
              this.props.checkerDetails.invoiceDetails?.OrderPdfLink
            )
            .then(() => {
              if (this.props.checkerDetails.urlFailure) {
                message.error(
                  "There seems to be an issue with this order, Please report to Tech"
                );
              } else {
                let printerData = {
                  printerDetails: {
                    printerId: selectPrinterByDesk(
                      this.props.history?.location?.state?.deskData
                        ?.deskDetailsList
                        ? this.props.history?.location?.state?.deskData
                            ?.deskDetailsList
                        : this.props.checkerDetails?.deskDetails
                            ?.deskDetailsList,
                      this.props.deskNumber
                    ),
                    contentType: "pdf_uri",
                    content: this.props.checkerDetails.invoiceDetails
                      .OrderPdfLink,
                    title: this.state.currentOrderId + " - Invoice",
                    source: "Checker",
                  },
                  history: this.props.history,
                };
                this.setState({
                  showPreview: true,
                  tempInvoiceLink: this.props.checkerDetails.invoiceDetails
                    .OrderPdfLink,
                });
                this.props.printPdfThunk(printerData).then(() => {
                  message.destroy();
                  if (this.props.dispatchDetails.printerError) {
                    message.error(this.props.dispatchDetails.printerError, 2);
                  } else if (this.props.dispatchDetails.printerDetails) {
                    message.success("Done", 1);
                    //  setTimeout(() => {
                    //   this.props.history.push("/markorder");
                    // }, 200);
                  } else {
                    message.error("Unknown error", 2);
                  }
                });
              }
            });
        } else {
          message.destroy();
          message.error("No url found", 2);
        }
      });
    }
  };

  changeBatchOrPack = (isBatchChange) => {
    this.setState(
      { selectedQty: this.calcSelectedQty(this.state.selectedMed?.batches) },
      () => {
        if (isBatchChange) {
          this.setState({
            isBatchChange: true,
            batchOrPackModal: true,
          });
        } else {
          this.searchMedsForMotherBrand(this.state.selectedMed?.name);
          this.setState({
            newPackBatchAdded: false,
            isBatchChange: false,
            batchOrPackModal: true,
          });
        }
      }
    );
  };

  searchMedsForMotherBrand = (name) => {
    if (name) {
      message.loading("Loading...", 0);
      let motherBrand = name.split(" ")[0];
      let data = {
        name: motherBrand,
        access_token: this.props.access_token,
      };
      this.props.fetchFromElasticSearchThunk(data).then(() => {
        message.destroy();
        if (this.props.checkerDetails.elasticMedDetailsError) {
          message.error(this.props.checkerDetails.elasticMedDetailsError);
        } else if (this.props.checkerDetails.elasticMedDetails) {
          this.setState({
            batchOrPackModal: true,
            isBatchChange: false,
          });
          if (
            this.props.checkerDetails.elasticMedDetails?.responses?.length >
              1 &&
            this.props.checkerDetails.elasticMedDetails?.responses[1]?.hits
              ?.hits?.length > 0
          ) {
            this.setState({
              allPackMeds: this.props.checkerDetails.elasticMedDetails
                ?.responses[1]?.hits?.hits,
            });
          }
        }
      });
    }
  };

  onChangeBatchSelect = (e) => {
    this.setState({ qtyChanged: true });
    let checked = e.target.checked;
    let arr = this.state.batchesById;
    arr[e.target.value].selected = e.target.checked;
    if (!checked) {
      arr[e.target.value].ogQty = 0;
    }
    this.setState(
      {
        selectedQty: this.calcSelectedQty(arr),
      },
      () => {
        if (this.state.requiredQty !== this.state.selectedQty) {
          this.setState({ batchesById: this.enableAllBatches(arr) });
        } else {
          this.setState({ batchesById: arr });
        }
      }
    );
  };

  changeBatchQty = (e, batchNo) => {
    this.setState({ qtyChanged: true });
    let arr = this.state.batchesById;
    for (let i in arr) {
      let b = arr[i];
      if (b.batchNumber === batchNo) {
        b.ogQty = e;
      }
    }
    this.setState(
      {
        batchesById: arr,
        selectedQty: this.calcSelectedQty(arr),
      },
      () => {
        if (this.state.requiredQty !== this.state.selectedQty) {
          this.setState({ batchesById: this.enableAllBatches(arr) });
        }
      }
    );
  };

  enableAllBatches = (batches) => {
    let finalArr = batches;
    for (let i in finalArr) {
      let batch = finalArr[i];
      batch.enabled = true;
    }
    return finalArr;
  };

  calcSelectedQty = (arr) => {
    let totalQty = 0;
    for (let i in arr) {
      let b = arr[i];
      if (b.selected && b.ogQty > 0) {
        totalQty = totalQty + b.ogQty;
      }
    }
    return totalQty;
  };

  preSetBatchQty = (batches) => {
    let arr = batches;
    let rQty = this.state.requiredQty;
    let sQty = this.state.selectedQty;
    for (let i in arr) {
      let batch = arr[i];
      if (rQty !== sQty) {
        if (rQty - sQty > batch.maxQty) {
          // batch.ogQty = batch.isBatchBlocked ? 0 : batch.maxQty;
          batch.ogQty = batch.maxQty;
        } else {
          // batch.ogQty = batch.isBatchBlocked ? 0 : rQty - sQty;
          batch.ogQty = rQty - sQty;
        }
        sQty = sQty + batch.ogQty;
        batch.selected = !batch.isBatchBlocked;
        batch.enabled = true;
      }
    }
    let finalArr = [];
    for (let i in arr) {
      let b = arr[i];
      if (b.ogQty > 0) {
        finalArr.push(b);
      }
    }
    let med = this.state.selectedMed;
    if (med) {
      med.batches = finalArr;
      this.setState({ selectedQty: sQty, selectedMed: med });
    }
  };

  updateBatches = (batches) => {
    let med = this.state.selectedMed;
    let finalArr = [];
    for (let i in batches) {
      let b = batches[i];
      if (b.ogQty > 0) {
        finalArr.push(b);
      }
    }
    med.batches = finalArr;
    if (med?.batches?.length > 0) {
      this.setState({ selectedMed: med }, () => {
        this.setState({ batchOrPackModal: false, qtyChanged: false });
      });
    } else {
      message.error("Please select batches");
    }
  };

  onChangePack = (e) => {
    let arr = this.state.allPackMeds;
    let obj = {};
    for (let i in arr) {
      let med = arr[i];
      if (med._source?.original_product_code === e) {
        obj = med._source;
        break;
      }
    }
    this.setState({
      changedMed: obj,
      packQty: this.setPackQty(arr, obj, this.state.selectedMed),
      isPackChange: true,
    });
  };

  setPackQty = (arr, changedMed, selectedMed) => {
    let qty = 0;
    let cMedTab = Number(changedMed?.original_pack);
    let sMedTab = null;
    for (let i in arr) {
      let med = arr[i];
      if (med._source?.original_product_code === selectedMed?.productCode) {
        sMedTab = Number(med._source?.original_pack);
        break;
      }
    }
    let totalQty = sMedTab * parseInt(selectedMed?.qty);
    qty = Math.ceil(totalQty / cMedTab);
    return qty;
  };

  setSrcTypeId = (meds) => {
    let id = 0;
    let arr = meds?.srcTypeMasterList;
    for (let i in arr) {
      let type = arr[i];
      if (type.value === "CHECKER PRODUCT ADD") {
        id = type.serialId;
        break;
      }
    }
    return id;
  };

  setMedActiveFalse = (meds, id) => {
    for (let i in meds) {
      let med = meds[i];
      if (med.productCode === id) {
        med.medActive = false;
        break;
      }
    }
    return meds;
  };

  packChangeAddMed = () => {
    message.loading("Adding...", 0);
    this.setState({ addMed: true });
    let data = {
      access_token: this.props.access_token,
      status: true,
      orderId: this.state.currentOrderId,
      finalSubsIdSet: [
        this.setfinalSubsIdSet(
          this.state.allMedDetails,
          this.state.selectedMed?.productCode
        ),
      ],
    };
    this.props.enableDisableMedsThunk(data).then(() => {
      if (this.props.checkerDetails.enableDisableError) {
        this.setState({ addMed: false });
        message.destroy();
        message.error(this.props.checkerDetails.enableDisableError);
      } else {
        // add med
        let medData = {
          access_token: this.props.access_token,
          srcTypeId: this.setSrcTypeId(this.props.checkerDetails.allMedDetails),
          medicineDetails: [
            {
              orderId: this.state.currentOrderId,
              subOrderId: this.props.checkerDetails.allMedDetails?.subOrderId,
              productCode: this.state.changedMed?.original_product_code,
              medicineName: this.state.changedMed?.original_sku_name,
              quantity: this.state.packQty,
              suppliedByTm: this.state.changedMed?.original_supplied_bytm,
              packSizeChangeProductId: this.setProductDetailsIdByProductCode(
                this.state.allMedDetails,
                this.state.selectedMed?.productCode
              ),
            },
          ],
        };
        this.props.addMedicineThunk(medData).then(() => {
          message.destroy();
          if (this.props.checkerDetails.addMedicineError) {
            this.setState({ addMed: false });
            message.destroy();
            message.error(this.props.checkerDetails.addMedicineError);
            let data = {
              access_token: this.props.access_token,
              status: false,
              orderId: this.state.currentOrderId,
              finalSubsIdSet: [
                this.setfinalSubsIdSet(
                  this.state.allMedDetails,
                  this.state.selectedMed?.productCode
                ),
              ],
            };
            this.props.enableDisableMedsThunk(data);
          } else {
            message.loading("Adding batches...", 0);
            this.props
              .getMedDetailsThunk({
                access_token: this.props.access_token,
                orderId: this.state.currentOrderId,
                history: this.props.history,
              })
              .then(() => {
                if (this.props.checkerDetails.allMedDetailsError) {
                  this.setState({ addMed: false });
                  message.destroy();
                  message.error(this.props.checkerDetails.allMedDetailsError);
                } else {
                  this.setState(
                    {
                      allMedDetails: this.props.checkerDetails.allMedDetails
                        ?.productSubsMappingList,
                      notSelectedMed: this.setMedActiveFalse(
                        this.state.notSelectedMed,
                        this.state.selectedMed?.productCode
                      ),
                    },
                    () => {
                      let data = {
                        access_token: this.props.access_token,
                        itemAvailableStockDto: {
                          warehouseId: warehouseId,
                          // warehouseId: 3,
                          productCodes: [
                            this.state.changedMed?.original_product_code,
                          ],
                        },
                      };
                      this.props.itemAvailableStockThunk(data).then(() => {
                        message.destroy();
                        this.setState({ addMed: false });
                        if (this.props.checkerDetails?.itemStockDetailsError) {
                          message.error(
                            this.props.checkerDetails?.itemStockDetailsError
                          );
                        } else {
                          let med = this.selectMedByProductCode(
                            this.state.allMedDetails,
                            this.state.changedMed?.original_product_code
                          );
                          if (med?.subsProductCd) {
                            let medicineDetails = {};
                            medicineDetails.name = med.subsMedName;
                            medicineDetails.medIssue = false;
                            medicineDetails.productCode = med.subsProductCd;
                            medicineDetails.orderId = this.state.currentOrderId;
                            medicineDetails.qty = med.subsQuantity;
                            medicineDetails.nsItemId = med.nsItemId;
                            medicineDetails.mrp = (
                              med.subsMrp / med.subsQuantity
                            ).toFixed(2);
                            medicineDetails.sp = (
                              med.subsSellingPrice / med.subsQuantity
                            ).toFixed(2);
                            medicineDetails.discount = (
                              ((med.subsMrp / med.subsQuantity -
                                med.subsSellingPrice / med.subsQuantity) *
                                100) /
                              (med.subsMrp / med.subsQuantity)
                            ).toFixed(2);
                            medicineDetails.batches = this.preSelectBatches(
                              this.props.checkerDetails?.itemStockDetails
                                ?.item_stock,
                              med
                            );
                            this.setState(
                              { selectedMed: medicineDetails },
                              () => {
                                this.setState(
                                  {
                                    requiredQty: this.state.selectedMed?.qty,
                                    selectedQty: 0,
                                    batchesById: this.state.selectedMed
                                      ?.batches,
                                    newPackBatchAdded: true,
                                  },
                                  () => {
                                    if (
                                      this.state.selectedMed?.batches?.length >
                                      0
                                    ) {
                                      this.preSetBatchQty(
                                        this.state.selectedMed?.batches
                                      );
                                    }
                                  }
                                );
                              }
                            );
                          }
                        }
                      });
                    }
                  );
                }
              });
          }
        });
      }
    });
  };

  selectMedByProductCode = (arr, code) => {
    let fMed = null;
    for (let i in arr) {
      let med = arr[i];
      if (med.subsProductCd === code) {
        fMed = med;
        break;
      }
    }
    return fMed;
  };

  setProductDetailsIdByProductCode = (arr, code) => {
    let id = null;
    for (let i in arr) {
      let med = arr[i];
      if (med.subsProductCd === code) {
        id = med.productDetailsId;
        break;
      }
    }
    return id;
  };

  setfinalSubsIdSet = (arr, code) => {
    let id = null;
    for (let i in arr) {
      let med = arr[i];
      if (med.subsProductCd === code && med.medActive) {
        id = med.finalSubsId;
        break;
      }
    }
    return id;
  };

  getSpForBatch = (mrp, discount) => {
    let sp = 0;
    if (mrp && discount) {
      sp = mrp - (mrp * discount) / 100;
    }
    return sp.toFixed(2);
  };

  disableVerifyBtn = () => {
    let disabledBatches = [];
    let disableMed = false;

    this.state.selectedMed?.batches?.map((k) =>
      k.ogQty > 0 && k.isBatchBlocked ? disabledBatches.push(k) : null
    );

    this.state.selectedMed?.batches?.filter((k) => k.isProductBlocked)?.length >
    0
      ? (disableMed = true)
      : (disableMed = false);

    let isDisable =
      this.props.isLoading ||
      !this.state.selectedMed ||
      !this.state.selectedMed?.batches ||
      this.state.selectedMed?.batches?.length === 0 ||
      disabledBatches.length > 0 ||
      disableMed;

    return isDisable;
  };

  render() {
    window.addEventListener("beforeunload", function (e) {
      // Cancel the event
      e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
      // Chrome requires returnValue to be set
      e.returnValue = "";
    });

    const columns = [
      {
        title: "Medicine Name",
        dataIndex: "name",
        key: "name",
        render: (text) => {
          return {
            children: (
              <span style={{ color: "#000", fontWeight: 600 }}>{text}</span>
            ),
          };
        },
      },
    ];

    if (this.state.isFinalScreen) {
      return this.state.errorFinalScreen ? (
        /////////////////////////////////////////////////
        //? Final error checked Screen
        /////////////////////////////////////////////////

        <div className="centerScreen">
          <Result
            status="warning"
            title="Order update found"
            subTitle="Thank You, Picker will be notified for this order."
            extra={
              <button
                className="bbtn"
                disabled={this.props.isLoading}
                onClick={() => this.props.history.push("/markorder")}
              >
                Go to home
              </button>
            }
          />

          {this.state.showScannerScreen && (
            <BarcodeScanner
              scan={this.state.showScannerScreen ? true : false}
              camera={this.state.showScannerScreen ? true : false}
              orderId={this.state.currentOrderId}
              history={this.props.history}
              currentBoxId={this.state.currentBoxId}
              redirectMissing="MissingZone"
              getBoxId={this.updateBoxId}
            />
          )}
        </div>
      ) : (
        /////////////////////////////////////////////////
        //? Final success checked Screen
        /////////////////////////////////////////////////

        <div className="centerScreen">
          <Result
            status="success"
            title="All medicines are checked"
            // subTitle="Please click submit button below and put your medicine box on table for checkers."
            extra={
              <Button
                type="link"
                key="console"
                onClick={() =>
                  this.setState({ showMedTable: !this.state.showMedTable })
                }
              >
                {`${this.state.showMedTable ? "Hide" : "Show"} order summary`}
              </Button>
            }
          />

          {this.state.showMedTable && (
            <Table
              dataSource={this.state.updatedMedData}
              columns={columns}
              bordered
              pagination={this.state.updatedMedData.length > 10}
            />
          )}

          <FooterButtons>
            <button
              className="bbtn"
              onClick={() => this.printInvoice()}
              disabled={this.props.isLoading || !this.state.isInVoiceCreated}
            >
              <FiPrinter />
              Print Invoice
            </button>
          </FooterButtons>

          <PreviewWrapper>
            <Modal
              title={"Invoice"}
              visible={this.state.showPreview}
              onCancel={() =>
                this.setState({ showPreview: false }, () => {
                  setTimeout(() => {
                    this.props.history.push("/markorder");
                  }, 200);
                })
              }
              footer={null}
              bodyStyle={{ padding: "10px" }}
            >
              <div>
                {/* <iframe
                  style={{
                    width: "100%",
                    height: "60vh",
                    "border-radius": "4px",
                  }}
                  src={this.state.tempInvoiceLink}
                ></iframe> */}
              </div>
            </Modal>
          </PreviewWrapper>

          <Modal
            title="Confirm Picked?"
            visible={this.state.isConfirmSubmit}
            onOk={() => this.handlePicked()}
            centered
            onCancel={() => this.setState({ isConfirmSubmit: false })}
          />
        </div>
      );
    } else {
      /////////////////////////////////////////////////
      //? Medicine Checker Screen
      /////////////////////////////////////////////////

      return (
        <div className="centerScreen">
          <OrderDetails
            pickerName={this.state.currentOrderData?.pickerName}
            orderId={this.state.currentOrderId}
            customerName={this.state.currentOrderData?.customerName}
            invoiceDate={this.state.currentOrderData?.invoiceDate}
            paymentType={this.state.currentOrderData?.paymentType}
            orderValue={
              this.state.deletedInvoice
                ? this.props.checkerDetails.allMedDetails?.finalCalcAmt
                    ?.finalAmount
                : this.state.currentOrderData?.orderValue
            }
            boxId={this.state.currentBoxId}
            tagColor={this.state.color}
            tagText={this.state.text}
            updateBox={this.changeBoxModal}
            isLoading={this.state.serviceLoading}
          />

          {this.state.showScannerScreen && (
            <BarcodeScanner
              scan={this.state.showScannerScreen ? true : false}
              camera={this.state.showScannerScreen ? true : false}
              orderId={this.state.currentOrderId}
              history={this.props.history}
              getBoxId={this.updateBoxId}
            />
          )}
          <MedicineLog type={2} />

          <RxWrapper
            data={this.state.orderSummaryData}
            customerRxImgs={this.state.customerRxImgs}
            customerRxPdfs={this.state.customerRxPdfs}
            doctorRxImgs={this.state.doctorRxImgs}
            doctorRxPdfs={this.state.doctorRxPdfs}
            toggleVisible={this.toggleVisible}
            viewCurrPDF={this.viewCurrPDF}
          />

          <Divider>Medicine Details</Divider>

          {this.state.selectedMed && this.state.allMedDetails?.length > 0 ? (
            <MedBoxChecker>
              <div
                className={`medName ${
                  this.state.selectedMed?.batches?.filter(
                    (k) => k.isProductBlocked
                  )?.length
                    ? "blocked"
                    : ""
                }`}
              >
                {this.state.selectedMed?.name}

                {this.state.selectedMed?.batches?.filter(
                  (k) => k.isProductBlocked
                )?.length > 0 ? (
                  <Tag icon={<CloseCircleOutlined color="error" />}>
                    Medicine blocked!
                  </Tag>
                ) : null}
              </div>

              <div>
                <p className="title">Batch Name</p>
                <p className="title">MRP</p>
                <p className="title">QTY</p>
              </div>

              {this.state.selectedMed?.batches?.map((item, pos) => (
                <div className="batchList" key={pos}>
                  <p>
                    {item.batchNumber}{" "}
                    <span className="warn">Exp. {item.expiryDate}</span>
                    {item?.isBatchBlocked ? (
                      <Tag icon={<CloseCircleOutlined color="error" />}>
                        Batch blocked!
                      </Tag>
                    ) : null}
                  </p>
                  <p>
                    ₹{item.mrp}
                    <span className="success">
                      ₹
                      {this.getSpForBatch(
                        item.mrp,
                        this.state.selectedMed?.discount
                      )}
                    </span>
                    <span className="success">
                      ({this.state.selectedMed?.discount}
                      %)
                    </span>
                  </p>
                  <p>{item.ogQty}</p>
                </div>
              ))}

              <div className="editContainer">
                <p
                  className={`${
                    this.state.selectedMed?.batches?.filter(
                      (k) => k.isProductBlocked
                    )?.length > 0 || this.props.isLoading
                      ? "blocked"
                      : ""
                  }`}
                  // style={{
                  //   pointerEvents: this.props.isLoading ? "none" : "",
                  // }}
                  onClick={() => this.changeBatchOrPack(true)}
                >
                  Change Batch
                </p>
                {/* <p
                  style={{
                    pointerEvents: this.props.isLoading ? "none" : "",
                  }}
                  onClick={() => this.changeBatchOrPack(false)}
                >
                  Pack Change
                </p> */}
              </div>
            </MedBoxChecker>
          ) : (
            <Empty
              style={{ margin: "10vh 0" }}
              description="No Medicine found"
            />
          )}

          <Viewer
            className="viewer-section"
            visible={this.state.visible}
            noClose={false}
            onClose={() => {
              this.setState({ visible: false });
            }}
            images={
              this.state.customerRxImgs.length > 0
                ? this.state.customerRxImgs
                : [{ src: "", alt: "" }]
              // this.state.visible ? [this.state.visible] : [{ src: "", alt: "" }]
            }
            // activeIndex={this.state.activeIndex}
            container={null}
            activeIndex={slideIndex}
            defaultScale={1.2}
            minScale="1"
            maxScale="3"
            zoomSpeed="0.5"
            zIndex="10000"
            defaultSize={{ width: 800, height: 800 }}
          />

          <Modal
            wrapClassName="updateMedBatchModal viewPDFModal"
            title="View PDF"
            open={this.state.viewPdfURL}
            footer={null}
            destroyOnClose={true}
            onCancel={() => this.setState({ viewPdfURL: null })}
          >
            {/* <ReactPDF
              file={{
                url: this.state.viewPdfURL,
              }}
            /> */}
            {/* <iframe
              src={this.state.viewPdfURL}
              title="pdf"
              width="100%"
              height="100%"
            /> */}
            {/* <object
              data={this.state.viewPdfURL}
              type="application/pdf"
              width="100%"
              height="100%"
            >
              <p>Alternative PDF</p>
            </object> */}

            <embed
              className="pdfobject"
              src={this.state.viewPdfURL}
              type="application/pdf"
              style={{
                overflow: "auto",
                width: "100%",
                height: "100%",
              }}
              internalinstanceid="30"
            ></embed>
          </Modal>

          <Modal
            wrapClassName="updateMedBatchModal"
            title="Update Medicine Batch"
            visible={this.state.batchOrPackModal}
            footer={null}
            onCancel={() => this.setState({ batchOrPackModal: false })}
            closable={!this.state.addMed && !this.state.qtyChanged}
          >
            <div className="updateMedBatchContainer">
              <div className="updateMedBatchHeader">
                <p>Medicine Name</p>
                <Select
                  disabled={this.state.isBatchChange ? true : false}
                  placeholder="Select Medicine"
                  style={{ width: "100%" }}
                  value={
                    this.state.isPackChange
                      ? this.state.changedMed?.original_product_code
                      : this.state.selectedMed?.name
                  }
                  onChange={this.onChangePack}
                >
                  {this.state.allPackMeds?.length > 0 &&
                    this.state.allPackMeds.map(
                      (item, pos) =>
                        this.state.selectedMed?.productCode !==
                          item._source?.original_product_code && (
                          <Option
                            key={pos}
                            value={item._source?.original_product_code}
                          >
                            {item._source?.original_sku_name}
                          </Option>
                        )
                    )}
                </Select>
                <p style={{ marginTop: "10px" }}>
                  Quantity:{" "}
                  {this.state.isPackChange
                    ? this.state.packQty
                    : this.state.requiredQty}
                </p>
                {this.state.isPackChange &&
                  this.state.packQty &&
                  !this.state.newPackBatchAdded && (
                    <button
                      className="packChangeAddMedButton"
                      onClick={this.packChangeAddMed}
                      disabled={this.state.addMed}
                    >
                      Add Med
                    </button>
                  )}
              </div>
              {(this.state.isBatchChange || this.state.newPackBatchAdded) && (
                <>
                  <div className="updateMedBatchTable">
                    <div className="updateMedBatchTitle">Batch Name</div>
                    <div
                      style={{ textAlign: "center" }}
                      className="updateMedBatchTitle"
                    >
                      QTY
                    </div>
                    {this.state.batchesById?.length > 0 &&
                      this.state.batchesById.map((batch, pos) =>
                        batch.maxQty > 0 ? (
                          <>
                            <div
                              style={{
                                border:
                                  this.state.batchesById.length === pos + 1
                                    ? "none"
                                    : "",
                              }}
                              className="updateMedBatchName"
                            >
                              <Checkbox
                                disabled={
                                  (!batch.enabled && batch?.isBatchBlocked) ||
                                  batch?.expiryNearBy ||
                                  batch?.isBatchBlocked
                                }
                                checked={batch.selected}
                                value={pos}
                                onChange={this.onChangeBatchSelect}
                              >
                                <span>{batch.batchNumber}</span>
                              </Checkbox>
                            </div>
                            <div
                              style={{
                                border:
                                  this.state.batchesById.length === pos + 1
                                    ? "none"
                                    : "",
                              }}
                              className="updateMedBatchQty"
                            >
                              <IncrementDecrementInput
                                disabled={
                                  !batch.selected || batch?.isBatchBlocked
                                }
                                min={0}
                                max={batch.maxQty}
                                value={batch.ogQty}
                                step={1}
                                handleChange={(e) => {
                                  this.changeBatchQty(e, batch.batchNumber);
                                }}
                              />
                            </div>
                          </>
                        ) : null
                      )}
                  </div>
                  <div className="updateMedBatchQtyFullfilled">
                    {this.state.selectedQty === this.state.requiredQty ? (
                      <p>
                        Quantity fullfilled :{" "}
                        <span>{this.state.selectedQty}</span> /{" "}
                        {this.state.requiredQty}
                      </p>
                    ) : (
                      <p style={{ color: "#E55934" }}>
                        Quantity conflict :{" "}
                        <span>{this.state.selectedQty}</span> /{" "}
                        {this.state.requiredQty}
                      </p>
                    )}
                    <button
                      className="bbtn"
                      disabled={
                        this.state.selectedQty === this.state.requiredQty
                          ? false
                          : true
                      }
                      onClick={() => this.updateBatches(this.state.batchesById)}
                    >
                      Submit
                    </button>
                  </div>
                </>
              )}
            </div>
          </Modal>

          <Modal
            title={``}
            footer={null}
            open={this.state.alreadyPrintedModalError}
            maskClosable={false}
            centered
            onCancel={() => this.setState({ alreadyPrintedModalError: false })}
          >
            <Result
              status="warning"
              title="Error Occured"
              extra={<p>{this.props.checkerDetails.invoiceDetailsError}</p>}
            />
          </Modal>

          <Modal
            title="Medicine Issue ?"
            visible={this.state.medIssueModal}
            className="medIssueModal"
            okText="Submit"
            onOk={this.saveMissingMeds}
            onCancel={() => this.setState({ medIssueModal: false })}
          >
            <MedIssueModalWrapperPicker>
              <div>
                {this.state.selectedMed ? (
                  <MedBoxChecker>
                    <div className="medName">
                      {this.state.selectedMed?.name}
                    </div>
                    {this.state.selectedMed.batches.map((item, pos) => (
                      <div className="batchListModal" key={pos}>
                        <p>
                          {item.batchNumber}
                          <span className="warn">Exp. {item.expiryDate}</span>
                        </p>
                        <p>{item.ogQty}</p>
                        <p>
                          <Select
                            name="missingMed"
                            style={{ width: "100%" }}
                            value={item.reasonId}
                            onChange={(value) =>
                              this.handleReasonChange(value, pos)
                            }
                            placeholder="Select a reason"
                          >
                            {this.state.medReasonData?.map(
                              (i, pos) =>
                                i.value !== "Picked" &&
                                i.value !== "Cold Chain" && (
                                  <Option value={i.reasonId} key={pos}>
                                    {i.value}
                                  </Option>
                                )
                            )}
                          </Select>
                        </p>
                        <p>
                          <IncrementDecrementInput
                            disabled={!item.reasonId}
                            min={0}
                            max={
                              this.state.deletedInvoice
                                ? this.getPriceDetails(
                                    this.state.allMedDetails,
                                    this.state.selectedMed,
                                    "qty"
                                  )
                                : item.ogQty
                            }
                            value={item.quantity}
                            step={1}
                            handleChange={(e) => {
                              this.handleBatchEdit(e, pos);
                            }}
                          />
                        </p>
                      </div>
                    ))}
                  </MedBoxChecker>
                ) : (
                  <Empty
                    style={{ margin: "5vh 0" }}
                    description="No Medicine found"
                  />
                )}
              </div>

              <Divider>Or</Divider>

              <button
                className="bbtn"
                disabled={this.props.isLoading}
                onClick={() => this.setState({ coldChainConfirmModal: true })}
              >
                <GiThermometerCold /> Cold Chain
              </button>
            </MedIssueModalWrapperPicker>
          </Modal>

          <Modal
            title={`Mark Order ID : ${this.state.currentOrderId} as cold chain ?`}
            visible={this.state.coldChainConfirmModal}
            // centered
            onOk={this.markOrderColdChain}
            onCancel={() => this.setState({ coldChainConfirmModal: false })}
          />

          <FooterButtons>
            <button
              className="bbtn"
              disabled={!this.state.selectedMed || this.props.isLoading}
              onClick={() => this.setState({ medIssueModal: true })}
            >
              <RiErrorWarningLine /> Update Medicine
            </button>

            <button
              className="bbtn"
              onClick={this.pickMedFunction}
              disabled={this.disableVerifyBtn()}
            >
              Verify ({" "}
              {`${this.state.updatedMedData.length + 1} / ${
                this.state.medData.length
              }`}{" "}
              )
            </button>
          </FooterButtons>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  pickerDetails: state.pickerorderReducer,
  onlineCheck:
    state.onlineStatusReducer?.isUserOnine?.response?.availableStatus?.value,
  pdf: state.packageTrackerReducer,
  orderContent: state.markorderReducer,
  checkerDetails: state.newCheckerOrderReducer,
  deskNumber: state.statusReducer.deskNumber,
  dispatchDetails: state.dispatchReducer,
  isLoading: state.LoaderReducer?.isLoading,
});

export default withRouter(
  connect(mapStateToProps, {
    pickerOrderDetailsThunk,
    updatePackageStatusThunk,
    saveMissingMedicineDetails,
    clearPickerDetails,
    markOrderDetailsThunk,
    getScannedCheckerOrderDetailsThunk,
    saveCheckerMissingMedicineDetails,
    getMedDetailsThunk,
    editMrpThunk,
    checkIfInvoiceExistsInZohoThunk,
    deleteInvoiceThunk,
    changeQtyThunk,
    addOrUpdateDeskNumberThunk,
    createInvoiceThunk,
    generateInvoicePdfThunk,
    printPdfThunk,
    getOrderItembatchesFromNetsuitThunk,
    fetchFromElasticSearchThunk,
    enableDisableMedsThunk,
    addMedicineThunk,
    itemAvailableStockThunk,
    getOrderSummaryDetailsThunk,
    checkUrlThunk,
  })(CheckerOrderPage)
);
